// extracted by mini-css-extract-plugin
export default {"item":"PaymentMethodsList_item__Kmmau","checkbox":"PaymentMethodsList_checkbox__rALzr"};